module.exports = new __parcel__URL__("temp.1ca9d45d.svg").toString();